module.exports = __webpack_public_path__ + "static/media/kid10.9d20caf3.png";